import './Title.css'

const Title = () => 
    <div className='title'>
        <span className='orange'>LIGHTS </span>
        <span className="blue">OUT</span>
    </div>

export default Title